import { createContext } from 'react';
import { SectionDataWeb } from '@nucleus/types/web';

export interface SectionsContextValue {
  sections: Map<string, SectionDataWeb>;
  getSection: (id: string) => SectionDataWeb | undefined;
}
export const SectionsContext = createContext<SectionsContextValue>({} as SectionsContextValue);
